export const bodyHasClasses = classes =>
  classes.every(klass => document.body.classList.contains(klass))
